import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { Modal } from '@beef/ui-kit';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { SimpleModalWrapper } from "../../_shared/utils/SimpleModalWrapper";
import { sberActions } from "../../store/features/sberpay/actions";
import { getShowPaymentProcess } from "../../store/features/sberpay/selectors";
import { getIsRedesign } from "../../store/common/selectors";
var ProcessWrapper = function ProcessWrapper(_ref) {
  var children = _ref.children,
    onCloseModal = _ref.onCloseModal,
    showModal = _ref.showModal;
  React.useEffect(function () {
    return function () {
      if (!showModal) onCloseModal();
    };
  }, []);
  if (showModal) {
    return /*#__PURE__*/React.createElement(Modal, {
      isCentered: true,
      isOpen: true,
      onClose: onCloseModal,
      size: "s"
    }, children);
  }
  return /*#__PURE__*/React.createElement(SimpleModalWrapper, {
    onClose: onCloseModal
  }, children);
};
ProcessWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  onCloseModal: PropTypes.func,
  showModal: PropTypes.bool
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: getShowPaymentProcess(state),
    showModal: !getIsRedesign(state)
  };
};
export default compose(connect(mapStateToProps, {
  onCloseModal: sberActions.closeProcessModalAction
}), withRenderFlag)(ProcessWrapper);